// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-stat{--text-opacity:1;color:#cbd5e0;color:rgba(203,213,224,var(--text-opacity))}.user-stat span{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity));font-size:1.25rem;margin-right:.5rem}", ""]);
// Exports
module.exports = exports;
